import React from "react";
import { Modal, Tabs } from "antd";

import TransactionPlanExcelUpload from "./TransactionPlanExcelUpload";
import ManualTransactionPlanForm from "./ManualTransactionPlanForm";
import { useTranslation } from "../../i18n/LanguageProvider";

/**
 * Add dialog of the Гүйлгээний төлөвлөгөө module.
 *
 * Both ways of adding data live in the one module page, so the sidebar keeps a single entry.
 * Only users with the ADD+VIEW permission can open it, and the backend enforces the same rule.
 */
function TransactionPlanAddModal({ open, onClose, onSaved }) {
    const { t } = useTranslation();

    const handleSaved = () => {
        onSaved?.();
        onClose?.();
    };

    const items = [
        {
            key: "excel",
            label: t("add.tab.excel"),
            children: <TransactionPlanExcelUpload onImportSuccess={handleSaved} />,
        },
        {
            key: "manual",
            label: t("add.tab.manual"),
            children: <ManualTransactionPlanForm onSaved={handleSaved} />,
        },
    ];

    return (
        <Modal
            title={t("add.modalTitle")}
            open={open}
            onCancel={onClose}
            width={1080}
            footer={null}
            destroyOnClose
        >
            <Tabs defaultActiveKey="excel" items={items} />
        </Modal>
    );
}

export default TransactionPlanAddModal;
